$color-active-step: #d3dae2;
$color-progress-bar: #ff6600;
.profileCompletion__steps {
  display: flex;
  margin: 0 -15px;
}

.profileCompletion__progressBar {
  position: relative;
}

.profileCompletion__progressBar {
  height: 10px;
  background-color: $color-progress-bar;
  display: block;
  position: absolute;
  bottom: 0;
}

.profileCompletion__stepContainer {
  min-height: 550px;
  padding: 15px;

  @media (max-width: 991px) {
    height: auto;
  }
}